import { PlaceholderScreen } from '@words-happen/screens';
import type React from 'react';

export interface PlaceholderPageProps {
  title: string;
}

/** A blank page holding a route until its screen is built. */
export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title }) => <PlaceholderScreen title={title} />;
